import { ColorPicker, TextField } from "components";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { defaultTagValues } from "utils";

interface IModalEdit {
    onClose: () => void;
    onConfirm?: (a: any) => void;
    item?: any;
}

export default function TagForm({ onClose, onConfirm, item }: IModalEdit) {
    const {
        register,
        setValue,
        control,
        handleSubmit,
    } = useForm({ defaultValues: item ?? defaultTagValues });

    return (
        <div className="mx-auto bg-white rounded-lg  ">
            <div className="content-modal p-4">
                <div className="grid md:grid-cols-3 gap-3 grid-cols-1">
                    <div>
                        <label className="block font-medium mb-1">Tên:</label>
                        <TextField
                            type="text"
                            placeholder="Nhập họ tên"
                            {...register("name")}
                        />
                    </div>
                    <div className="shadow-none w-50">
                        <label className="block font-medium mb-1">Màu sắc:</label>
                        <Controller
                            control={control}
                            name="color"
                            render={({ field }) => (
                                <ColorPicker {...field} onInput={(v) => setValue('color', v)} />
                            )}
                        />
                    </div>

                </div>

            </div>
            <div className="flex justify-center gap-2 p-4">
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600"
                >
                    Huỷ
                </button>
                {!!onConfirm && <button
                    onClick={() => handleSubmit(onConfirm)()}
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
                >
                    Xác nhận
                </button>}
            </div>
        </div>
    );
}
